import { lazy, Suspense } from "react";
import { PageSkeleton } from "../../customs/skeleton/main";
const Main = lazy(() => import("../../components/settings/uploadDocSetup/main"));

const UploadDocumentSetUp= () => {
  return (
      <Suspense fallback={<PageSkeleton />}>
        <Main />
      </Suspense>
  );
};

export default UploadDocumentSetUp;
